import { UserBlob, api } from 'api'

export const setUserInfo = async ({ email, phone }: { email: string; phone: string }): Promise<UserBlob> => {
  const response = await api.accounts.setUserInfo(email, phone)

  return response.data
}
